export default {
  name: 'UpdateArticle',
  props: {
    length: {
      type: [String, Number],
      default: 3
    },
    moreArticle: String
  },
  data() {
    return {
      posts: [],
      currentPath: ''
    };
  },
  created() {
    this.posts = this.$site.pages;
    this.currentPath = this.$page.path;
  },
  computed: {
    topPublishPosts() {
      return this.$sortPostsByDate ? this.$sortPostsByDate.filter(post => {
        const {
          path
        } = post;
        return path !== this.currentPath;
      }).slice(0, this.length) : [];
    },
    isShowArticle() {
      const {
        frontmatter
      } = this.$page;
      return !(frontmatter.article !== false);
    }
  },
  methods: {
    getNum(index) {
      return index < 9 ? '0' + (index + 1) : index + 1;
    },
    getDate(item) {
      return item.frontmatter.date ? item.frontmatter.date.split(" ")[0].slice(5, 10) : '';
    }
  },
  watch: {
    $route() {
      this.currentPath = this.$page.path;
    }
  }
};